import { useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { AUTH_STATE, ROUTE_ALIASES } from '@/types';
import { Center, Loader, Text } from '@mantine/core';
import AuthService from '@/services/auth.service';

export const Login = () => {
  const { state } = useAuth();
  const location = useLocation();
  const origin = location.state?.from?.pathname || ROUTE_ALIASES.HOME;
  const hasStartedSignInRef = useRef<boolean>(false);

  useEffect(() => {
    if (state === AUTH_STATE.UNAUTHENTICATED && !hasStartedSignInRef.current) {
      hasStartedSignInRef.current = true;
      AuthService.signIn();
    }
  }, [state]);

  return (
    <Center h="100vh">
      {state === AUTH_STATE.LOADING && <Loader size="lg" />}
      {state === AUTH_STATE.UNAUTHENTICATED && <Text size="xl">Unauthenticated</Text>}
      {state === AUTH_STATE.AUTHENTICATED && <Navigate to={origin} />}
    </Center>
  );
};
